import { render, staticRenderFns } from "./NewYearTimer.vue?vue&type=template&id=e1444412&scoped=true"
import script from "./NewYearTimer.vue?vue&type=script&lang=js"
export * from "./NewYearTimer.vue?vue&type=script&lang=js"
import style0 from "./NewYearTimer.vue?vue&type=style&index=0&id=e1444412&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1444412",
  null
  
)

export default component.exports